import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Services", href: "#services" },
    { name: "Why Us", href: "#why-us" },
    { name: "Security", href: "#security" },
    { name: "Closing Options", href: "#closing-options" },
    { name: "Core Team", href: "#team" },
    { name: "FAQ", href: "#faq" },
    { name: "Calculator", href: "/calculator" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "glass py-3" : "bg-transparent py-5"
      }`}
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <nav className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3" data-testid="logo-link">
            <img
              src={isScrolled
                ? "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/bbq6kb7o_ALA2.BMP"
                : "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/5leqzq80_image.png"
              }
              alt="American Legal Abstract"
              className={`h-10 md:h-12 w-auto ${!isScrolled ? 'brightness-105' : ''}`}
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6 ml-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm font-semibold btn-transition ${
                  isScrolled ? 'text-[#64748B] hover:text-[#0F172A]' : 'text-[#0F172A] hover:text-[#B45309]'
                }`}
                data-testid={`nav-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-[#0F172A] text-white px-6 py-3 text-xs font-bold uppercase tracking-widest hover:bg-[#1e293b] btn-transition"
              data-testid="header-contact-btn"
            >
              <Phone className="w-4 h-4" strokeWidth={1.5} />
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-[#0F172A]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-[#E7E5E4] shadow-lg" data-testid="mobile-menu">
            <div className="px-6 py-4 space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block text-sm font-medium text-[#64748B] hover:text-[#0F172A] py-2"
                  onClick={(e) => {
                    if (!link.href.startsWith("#")) {
                      setIsMobileMenuOpen(false);
                      return;
                    }
                    e.preventDefault();
                    setIsMobileMenuOpen(false);
                    const target = document.querySelector(link.href);
                    if (target) {
                      target.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  {link.name}
                </a>
              ))}
              <a
                href="#contact"
                className="block text-center bg-[#0F172A] text-white px-6 py-3 text-xs font-bold uppercase tracking-widest"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMobileMenuOpen(false);
                  const target = document.querySelector('#contact');
                  if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Get Started
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
